// apiClient.ts
import axios from 'axios';
import { API_BASE_URL } from '@/constants';

// Create an Axios instance for authenticated requests
const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

// Add a request interceptor to include the auth token in every request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

apiClient.interceptors.response.use((response) => {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, (error) => {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  if (error?.response?.status === 401) {
    localStorage.setItem('auth_token', '');
    window.location.href = '/signin';
  }
  // Do something with response error
  return Promise.reject(error);
});

// Create an Axios instance for unauthenticated requests
const unauthenticatedApiClient = axios.create({
  baseURL: API_BASE_URL,
});

export { apiClient, unauthenticatedApiClient };
